import React from 'react'
import PropTypes from 'prop-types'
import {Box, useBreakpointValue} from '@salesforce/retail-react-app/app/components/shared/ui'
import {Swiper, SwiperSlide} from 'swiper/react'
import Title from '../shop-the-look/partials/title'
import Description from '../shop-the-look/partials/description'
import 'swiper/css'

import PDComponent from '../../pd-component'

export const ShopTheLookSlider = ({regions, sliderBg, ...rest}) => {
    const slides = regions?.flatMap((region) => region?.components).length || 0
    const isSwiperEnabled = useBreakpointValue({
        base: true,
        sm: slides > 2,
        lg: slides > 3,
        '2xl': slides > 4
    })

    const {
        title,
        titleColor,
        titleSizeLargeDesktop,
        titleSizeMobile,
        titleSizeSmallDesktop,
        titleSizeTablet,
        titleTag,
        description,
        descriptionTag,
        descriptionFontFamily,
        descriptionColor,
        titleFontFamily,
        titleAlign,
        descriptionAlign
    } = rest

    const totalSlides = regions?.reduce((acc, region) => {
        return acc + (region?.components?.length || 0)
    }, 0)
    const isTwoSlides = totalSlides === 2

    return (
        <Box
            paddingBottom="20px"
            background={sliderBg ? sliderBg : 'white'}
            sx={{
                '.swiper': {
                    paddingRight: 0
                },
                '.swiper-wrapper': {
                    display: 'flex',
                    paddingLeft:
                        isTwoSlides || totalSlides >= 3
                            ? '0'
                            : {
                                  base: '20px',
                                  xs: '30px',
                                  lg: '40px'
                              },
                    justifyContent: isSwiperEnabled ? 'start' : 'center'
                },
                '.swiper-slide': {
                    marginRight: isTwoSlides || totalSlides >= 3 ? 0 : {base: 0, md: 2},
                    width: isTwoSlides
                        ? {
                              base: '100%',
                              xs: '100%',
                              md: '50%',
                              lg: '50%',
                              xl: '50%'
                          }
                        : {
                              base: '340px',
                              xs: '408px',
                              md: '325px',
                              lg: '344px',
                              xl: '364px',
                              '2xl':
                                  totalSlides >= 4 && totalSlides <= 5
                                      ? `calc(100% / ${totalSlides})`
                                      : '416px'
                          },

                    '&:last-child': {
                        marginRight:
                            isTwoSlides || totalSlides >= 3
                                ? '0 !important'
                                : {
                                      base: '20px !important',
                                      xs: '30px !important',
                                      lg: '40px !important'
                                  }
                    }
                }
            }}
        >
            <Box
                className="desktop-title-description"
                padding={{base: '20px 15px', md: '30px 40px 0 40px'}}
            >
                <Title
                    title={title}
                    titleColor={titleColor}
                    titleSizeLargeDesktop={titleSizeLargeDesktop}
                    titleSizeMobile={titleSizeMobile}
                    titleSizeSmallDesktop={titleSizeSmallDesktop}
                    titleSizeTablet={titleSizeTablet}
                    titleFontFamily={titleFontFamily}
                    titleTag={titleTag}
                    titleAlign={titleAlign}
                />
                <Description
                    description={description}
                    descriptionColor={descriptionColor}
                    descriptionFontFamily={descriptionFontFamily}
                    descriptionTag={descriptionTag}
                    descriptionAlign={descriptionAlign}
                />
            </Box>

            <Swiper slidesPerView={'auto'} enabled={isSwiperEnabled}>
                {regions?.map((region) =>
                    region?.components?.map((component, index) => (
                        <SwiperSlide key={`${region.id}-${index}`}>
                            <PDComponent component={component} noOfSlides={slides} />
                        </SwiperSlide>
                    ))
                )}
            </Swiper>
        </Box>
    )
}

ShopTheLookSlider.propTypes = {
    regions: PropTypes.array,
    sliderBg: PropTypes.string
}

export default ShopTheLookSlider
